import { CheckCircle, Filter, Star, Translate } from "iconoir-react";
import React, { memo, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import ArrowUpIcon from "../../components/image/ArrowUpIcon";
import ArrowLeftIcon from "../../components/image/ArrowLeftIcon";
import { useNavigate } from "react-router-dom";
import { inject, observer } from "mobx-react";
import SkeletonSubWorkTable from "../../components/Skeleton/SkeletonSubWorkTable";
import ImportantStar from "../../components/image/ImportantStar";
import { WORK_STATUS } from "../../utils/constants";
import CheckSuccessIcon from "../../components/image/CheckSuccessIcon";
import CheckLight from "../../components/image/CheckLight";
import { borderRadius } from "@mui/system";
import SkeletonTable from "../../components/Skeleton/SkeletonTable";

const TRANG_THAI_WIDTH = 120;
const CONG_VIEC_WIDTH = 241;
const NGUOI_XU_LY_WIDTH = 145;
const NGUOI_TAO_WIDTH = 151;
const HAN_HOAN_THANH_WIDTH = 162;
const WorkRow = (props) => {
    const navigate = useNavigate();
    const { row, subwork, workStore } = props;
    const [open, setOpen] = useState(false);
    const [subLoading, setSubLoading] = useState(false);

    const getSubWorkList = async (work_code) => {
        try {
            setSubLoading(true);
            await workStore.getListSubWork(work_code);
        } catch (error) {
            console.log(error);
        } finally {
            setSubLoading(false);
        }
    };
    const SubRow = (props) => {
        const { row } = props;
        return (
            <React.Fragment>
                <TableRow
                    onClick={() => {
                        navigate(`/work/view/${row.code}`);
                    }}
                    sx={{ "& > *": { borderBottom: "unset" } }}
                >
                    <TableCell
                        className="flex items-center justify-end gap-3 px-5"
                        component="td"
                        scope="row"
                    >
                        <div className="w-[40px]"></div>
                        {row?.important === true ? (
                            <ImportantStar />
                        ) : (
                            <Star width={17} height={17} color="#A2A2A2" />
                        )}
                        {row?.status === WORK_STATUS.COMPLETE ? (
                            <CheckSuccessIcon />
                        ) : (
                            <CheckLight />
                        )}
                    </TableCell>
                    <TableCell
                        width={CONG_VIEC_WIDTH}
                        component="td"
                        scope="row"
                    >
                        {row?.title}
                    </TableCell>
                    <TableCell width={NGUOI_XU_LY_WIDTH}>
                        {row?.calories}
                    </TableCell>
                    <TableCell width={NGUOI_TAO_WIDTH}>{row.fat}</TableCell>
                    <TableCell width={HAN_HOAN_THANH_WIDTH}>
                        {row?.carbs}
                    </TableCell>
                </TableRow>
            </React.Fragment>
        );
    };
    return (
        <React.Fragment>
            <TableRow
                onClick={() => {
                    navigate(`/work/view/${row.code}`);
                }}
                sx={{
                    "& > *": { borderBottom: "unset" },
                    // backgroundColor: "#F8F8F8",
                }}
            >
                <TableCell className="flex items-center justify-end gap-3 px-5 ">
                    {
                        <IconButton
                            sx={{
                                width: 40,
                                visibility: `${
                                    row.has_subwork === true
                                        ? "visible"
                                        : "hidden"
                                }`,
                            }}
                            aria-label="expand row"
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation();
                                if (
                                    !subwork.some(
                                        (item) => item?.parent_id === row?.code
                                    )
                                ) {
                                    getSubWorkList(row?.code);
                                }
                                setOpen(!open);
                            }}
                        >
                            {open ? <ArrowUpIcon /> : <ArrowLeftIcon />}
                        </IconButton>
                    }

                    {row.important === true ? (
                        <ImportantStar />
                    ) : (
                        <Star width={17} height={17} color="#A2A2A2" />
                    )}
                    {row.status === WORK_STATUS.COMPLETE ? (
                        <CheckSuccessIcon />
                    ) : (
                        <CheckLight />
                    )}
                </TableCell>
                <TableCell component="td" scope="row">
                    {row.title}
                </TableCell>
                <TableCell>{row.calories}</TableCell>
                <TableCell>{row.fat}</TableCell>
                <TableCell>{row.carbs}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell
                    style={{ padding: 0, transform: "translateX(35px)" }}
                    colSpan={6}
                >
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{}}>
                            <Table
                                width="100%"
                                size="medium"
                                aria-label="purchases"
                                sx={{
                                    [`& .${tableCellClasses.root}`]: {
                                        borderBottom: "none",
                                    },
                                    "& .MuiTableCell-root": {
                                        transform: "translateX(-35px)",
                                    },
                                    "& .MuiTableRow-root": {
                                        borderRadius: 20,
                                    },
                                    fontSize: 14,
                                    lineHeight: 24,
                                    borderCollapse: "separate",
                                    borderSpacing: "0px 6px",
                                }}
                            >
                                {subLoading ? (
                                    <SkeletonSubWorkTable />
                                ) : (
                                    <TableBody
                                        sx={{
                                            width: "100%",
                                        }}
                                    >
                                        {subwork
                                            ?.filter(
                                                (item) =>
                                                    item?.parent_id === row.code
                                            )
                                            ?.map((row) => (
                                                <SubRow
                                                    key={row.code}
                                                    row={row}
                                                />
                                            ))}
                                    </TableBody>
                                )}
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
};

export default memo(inject("workStore")(observer(WorkRow)));
